import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

import { InvestigatorForecastSourceSelectItemComponent } from './investigator-forecast-source-select-item/investigator-forecast-source-select-item.component';
import { Source } from '../../types/investigator-forecast.types';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InvestigatorForecastSourceSelectItemComponent],
  selector: 'aux-investigator-forecast-source-select',
  styles: [],
  templateUrl: './investigator-forecast-source-select.component.html',
})
export class InvestigatorForecastSourceSelectComponent {
  @Input() control!: FormControl;
  @Input() sources: Source[] = [];
}
